import React, { useState } from 'react'
import '../styles/SentakuStyle.css'

const imageSel = './images/select.png';

function SentakuA() {

      const [isHovered, setIsHovered] = useState(false);

        return (


    <div
    onMouseEnter={() => setIsHovered(true)}
    onMouseLeave={() => setIsHovered(false)}
    className='imageSelectionDiv'>

    { isHovered ? (
        <div className="isHoveredDiv">
        <img src={imageSel} id="img1" alt=""/>
        <a href="/Watashi" id='watashiSel'>私</a>
        <img src={imageSel} id="img2" alt=""/>
        </div>
    ) : (<a href='watashi.html' id='watashiSel'>me</a>
    )}
      </div>
  )
}

export default SentakuA
